<template>
  <v-card>
    <v-card-title class="headline grey lighten-2 mb-3">{{'warranty_info_title'|globalTranslate}}</v-card-title>

    <v-card-text>
      <p>{{'warranty_info_sentence1'|globalTranslate}}</p>
      <p>{{'warranty_info_sentence2'|globalTranslate}}</p>
      <p>{{'warranty_info_sentence3'|globalTranslate}}</p>
      <ul class="mb-2">
        <li>{{'warranty_info_list1'|globalTranslate(['25 €'])}}</li>
        <li>{{'warranty_info_list2'|globalTranslate(['40 €'])}}</li>
        <li>{{'warranty_info_list3'|globalTranslate(['50 €'])}}</li>
      </ul>
      <p>{{'warranty_info_sentence4'|globalTranslate}}</p>
      <h3 class="text-uppercase mb-1">{{'warranty_info_subtitle'|globalTranslate}}</h3>
      <p>{{'warranty_info_sentence5'|globalTranslate}}</p>
      <ul>
        <li>{{'warranty_info_list4'|globalTranslate}}</li>
        <li>{{'warranty_info_list5'|globalTranslate}}</li>
      </ul>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="d-flex flex-row-reverse">
      <v-btn color="primary" class="font-weight-bold"
             @click="onCancel">
        <v-icon left>mdi-chevron-right</v-icon>
        {{'close'|globalTranslate}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "WarrantyInfo",
  methods: {
    onCancel() {
      this.$emit('cancel', true);
    }
  }
}
</script>

<style scoped>

</style>